import { useTranslations } from "use-intl";
import { DrawerTopBar } from "../Drawer";
import type { HotelsSortValue } from "@/app/lib/types/types";
import HotelsListsSort from "./HotelsListSort";
import { SwipeableDrawer } from "../SwipeableDrawer";

type Props = {
  open: boolean;
  value: HotelsSortValue;
  onSubmit: (newValue: HotelsSortValue) => void;
  onClose: () => void;
};

export const HotelsSortDrawer = ({ open, value, onSubmit, onClose }: Props) => {
  const t = useTranslations();

  return (
    <SwipeableDrawer open={open} onClose={onClose}>
      <DrawerTopBar onCloseClick={onClose} title={t("hotels.filters.sort")} />
      <HotelsListsSort value={value} onChange={onSubmit} />
    </SwipeableDrawer>
  );
};
